module.exports = __webpack_public_path__ + "img/Upnita.2eaba722.jpg";